export function isCompleteValueDef(def) {
  return 'value' in def;
}
export function isCompleteFieldDef(def) {
  return 'field' in def;
}